export const gifMimeTypes = [
  "image/gif",
  'image/gif; version="87a"',
  'image/gif; version="89a"',
];
